/** Safe clipboard copy that falls back to document.execCommand when
 *  navigator.clipboard.writeText is unavailable or blocked (some
 *  permission contexts, iframes, non-secure pages, older browsers). */
import { logger } from "@/lib/logger";

export async function copyToClipboard(text) {
  if (!text) return false;
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (err) {
    logger.debug("clipboard.writeText failed, falling back:", err);
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return !!ok;
  } catch (err) {
    logger.warn("clipboard fallback failed:", err);
    return false;
  }
}
